var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    _vm._g(
      _vm._b(
        {
          ref: "modal",
          attrs: {
            hasCancelBtn: false,
            title: _vm.$t("tenantProjects.requestRefundConfirm"),
            size: "small",
          },
        },
        "HKLModal",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }